"use strict";
angular.module("xhsgConfigModule", [
        'manageSysXhsgCircuitServiceModule'
    ])
    .controller("xhsgConfigCtrl", ['$scope', '$q', '$state', 'trsHttpService', 'manageSysXhsgCircuitService', 'modalDialog', 'trsspliceString',
        function($scope, $q, $state, trsHttpService, manageSysXhsgCircuitService, modalDialog, trsspliceString) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {};
                $scope.data = {
                    items: [],
                    keywords: '',
                    selectedArray: []
                };
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
            }

            /**
             * [requestData 获取列表数据]
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'querryXHSLineAuthors',
                    authorTenantId: $state.params.tenantid,
                    PageSize: $scope.page.PAGESIZE,
                    PageIndex: $scope.page.CURRPAGE,
                };
                $scope.data.keywords == '' ? delete params.Keyword : params.Keyword = $scope.data.keywords;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                    $scope.data.selectedArray = [];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [createOrEdit 新建或编辑]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.createOrEdit = function(item) {
                manageSysXhsgCircuitService.createNewCircuitConfig(item, true).then(function(success) {
                    requestData();
                });
            };

            /**
             * [singleSelect 单选]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                var n = $scope.data.selectedArray.indexOf(item);
                n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [selectAll 全选]
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.items.length > 0 && $scope.data.items.length == $scope.data.selectedArray.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [];
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        $scope.data.selectedArray.push($scope.data.items[i]);
                    }
                }
            };

            /**
             * [switchStatus 切换状态]
             * @param  {[type]} status [description]
             * @return {[type]}        [description]
             */
            $scope.switchStatus = function(item) {
                var params;
                if (item.AUTHORSTATUS == 1) {
                    params = {
                        serviceid: 'mlf_xinhuashe',
                        methodname: 'stopXHSLineAuthor',
                        ObjectId: item.XHSLINEAUTHORID
                    };
                } else {
                    params = {
                        serviceid: 'mlf_xinhuashe',
                        methodname: 'openXHSLineAuthor',
                        ObjectId: item.XHSLINEAUTHORID
                    };
                }
                item.AUTHORSTATUS = item.AUTHORSTATUS == '1' ? '0' : '1';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    // if (data.ISSUCCESS === "true") {
                    modalDialog.alertType(data.DETAIL, '', data.ISSUCCESS == 'true' ? 'success' : 'error', false, function() {
                        requestData();
                    });
                    // }
                });
            };

            /**
             * [delete 删除配置]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.delete = function(item) {
                if (item.AUTHORSTATUS == '1') {
                    modalDialog.alertType('启用中线路无法删除，请先停用', '', 'info', 'confirm', function() {});
                    return;
                }
                modalDialog.alertType('确定删除选中配置项？', '', 'ask', true, function() {
                    var params = {
                        serviceid: 'mlf_xinhuashe',
                        methodname: 'deleteXHSLineAuthor',
                        ids: angular.isDefined(item) ? item.XHSLINEAUTHORID : trsspliceString.spliceString($scope.data.selectedArray, 'XHSLINEAUTHORID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType(data.DETAIL, '', data.ISSUCCESS == 'true' ? 'success' : 'error', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [renew 续费]
             * @return {[type]} [description]
             */
            $scope.renew = function() {
                if (filterBlockUp().length > 0) {
                    modalDialog.alertType('停用中的线路无法续费，请开启或重新选择线路', '', 'info', 'confirm', function() {})
                    return;
                }
                manageSysXhsgCircuitService.renewConfig($scope.data.selectedArray).then(function(success) {
                    requestData();
                });
            };

            function filterBlockUp() {
                var result = $scope.data.selectedArray.filter(function(item) {
                    return item.AUTHORSTATUS == '0';
                });
                return result;
            }

            /**
             * [querySearchByKeyword 快速检索]
             * @param  {[type]} e [description]
             * @return {[type]}   [description]
             */
            $scope.querySearchByKeyword = function(e) {
                if (e.keyCode == 13 || angular.isUndefined(e.keyCode)) {
                    requestData();
                }
            };

            /**
             * [goBack 返回]
             * @return {[type]} [description]
             */
            $scope.goBack = function() {
                $state.go('manageconfig.tenantmanagement.allTenantManage');
            };
        }
    ]);